export const enum DateFormat {
  TIME = 'HH:mm', // 22:00
  DAY = 'dd',
  DAY_WITH_SHORT_MONTH = 'dd LLL', // 1 Jan
  DATE = 'dd LLL yy', // 01 Jan 21
  SHORT_YEAR = 'yy', // 21
  SHORT_MONTH = 'LLL', // Jan
  SHORT_WEEKDAY = 'EEE', // Mon
  WEEKDAY_WITH_MONTH = 'EEEE, d LLLL' // Monday, 1 January
}
